import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { com } from '@eidu/web'
import { knownKinds } from '../../domain/kindRegistry'
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind
import entityTypeKindFromString = com.eidu.sharedlib.entity.type.entityTypeKindFromString

export type KindInputProps = {
  kind?: EntityTypeKind
  setKind?: (kind: EntityTypeKind) => void
  editable?: boolean
}

const sortedKnownKinds = [...knownKinds].sort((a, b) => a.toString().localeCompare(b.toString()))

const KindInput = ({ kind, setKind = () => {}, editable = false }: KindInputProps) => {
  const handleChange = (event: SelectChangeEvent) => setKind(entityTypeKindFromString(event.target.value))

  return (
    <Select value={kind?.toString()} onChange={handleChange} disabled={!editable} variant="outlined">
      {sortedKnownKinds.map((value) => (
        <MenuItem key={value.toString()} value={value.toString()}>
          {value.toString()}
        </MenuItem>
      ))}
    </Select>
  )
}

export default KindInput
